export default "__VITE_ASSET__oQvKXfPT__"